import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    marginBottom: '16px',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
})

interface CardDesc {
  help?: string
  title?: string
  genre?: string
  desc?: string
  link?: string
}

export default function SimpleCard({
  help,
  title,
  genre,
  desc,
  link,
}: CardDesc): JSX.Element {
  const classes = useStyles()

  return (
    <Card className={classes.root}>
      <CardContent>
        {help && (
          <Typography
            className={classes.title}
            color="textSecondary"
            gutterBottom
          >
            {help}
          </Typography>
        )}
        {title && (
          <Typography variant="h5" component="h2">
            {title}
          </Typography>
        )}
        {genre && (
          <Typography className={classes.pos} color="textSecondary">
            {genre}
          </Typography>
        )}
        {desc && (
          <Typography variant="body2" component="p">
            {desc}
          </Typography>
        )}
      </CardContent>
      {link && (
        <CardActions>
          <Button size="small" href={link} target={'_blank'}>
            Go to Link
          </Button>
        </CardActions>
      )}
    </Card>
  )
}
